import { render } from "./TheManagerCreation.vue?vue&type=template&id=5ec3d26a"
import script from "./TheManagerCreation.vue?vue&type=script&lang=js"
export * from "./TheManagerCreation.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__